import { Outlet, matchPath, useLocation } from 'react-router';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Suspense } from '@sorare/core/src/atoms/Suspense';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import {
  ANY_SPORT_HOME,
  FOOTBALL,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { matchAnySportPath } from '@sorare/core/src/lib/routing/generateSportPath';
import { CurrentUserTaskUpdatedToast } from '@sorare/gameplay/src/components/missions/CurrentUserTaskUpdatedToast';
import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { FootballMarketSubscriptions } from '#src/routing/FootballMarketSubscriptions/index.tsx';

const FootballLayout = () => {
  const { currentUser, footballUserProfile } = useCurrentUserContext();
  const location = useLocation();
  const { forcedIntoOnboarding } = currentUser || {};

  if (
    forcedIntoOnboarding &&
    !footballUserProfile?.commonGameOnboarded &&
    (matchPath(FOOTBALL, location.pathname) ||
      matchAnySportPath(ANY_SPORT_HOME, location.pathname, Sport.FOOTBALL))
  ) {
    return (
      <>
        <CurrentUserTaskUpdatedToast />
        <Outlet />
      </>
    );
  }
  return (
    <AppLayout>
      <FootballMarketSubscriptions />
      <CurrentUserTaskUpdatedToast />
      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
      </Suspense>
    </AppLayout>
  );
};
export default FootballLayout;
